import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantPage = {
  footer: {
    root: 'applicant-page.footer.root',
  },
  form: {
    h1: 'applicant-page.form.h1',
    h2: 'applicant-page.form.h2',
    root: 'applicant-page.form.root',
    submitButton: 'applicant-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
